module.exports = __webpack_public_path__ + "img/video.eb6cfc48.jpg";